import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

import Base from "@/layout/Base.vue";
import Blank from "@/layout/Blank.vue";

import Statistics from "@/views/Statistics.vue";
import SubmenuList from "@/views/SubmenuList";
import SubmenuCreate from "@/views/SubmenuCreate";
import SubmenuEdit from "@/views/SubmenuEdit";
import TopmenuCreate from "@/views/TopmenuCreate";
import TopmenuEdit from "@/views/TopmenuEdit";
import SubmenuShow from "@/views/SubmenuShow";
import AdminList from "@/views/AdminList";
import UserList from "@/views/UserList";
import InquiryList from "@/views/InquiryList";
import SendEbarimt from "@/views/SendEbarimt";
import AdminEdit from "@/views/AdminEdit";
import AdminPasswordChange from "@/views/AdminPasswordChange";
import AdminRegister from "@/views/AdminRegister";
import Banner from "@/views/Banner";
import BannerCreate from "@/views/BannerCreate";
import BannerEdit from "@/views/BannerEdit";
import EntryCreate from "@/views/EntryCreate";
import EntryEdit from "@/views/EntryEdit";
import Design from "@/views/Design";
import BannerStatisticDetail from "@/components/statistic/BannerStatisticDetail";

import Login from "@/views/Login";

var router = new Router({
  mode: "history",

  routes: [
    {
      path: "",
      component: Base,
      children: [
        {
          path: "/",
          name: "Statistics",
          component: Statistics
        },
        {
          path: "topmenu/create",
          name: "TopmenuCreate",
          component: TopmenuCreate
        },
        {
          path: "topmenu/edit/:id",
          name: "TopmenuEdit",
          component: TopmenuEdit
        },
        {
          path: "submenu",
          name: "SubmenuList",
          component: SubmenuList
        },
        {
          path: "submenu/create/:parentId",
          name: "SubmenuCreate",
          component: SubmenuCreate
        },
        {
          path: "submenu/edit/:id",
          name: "SubmenuEdit",
          component: SubmenuEdit
        },
        {
          path: "submenu/:parentId",
          name: "SubmenuShow",
          component: SubmenuShow
        },
        {
          path: "entry/create/:type/:parentId",
          name: "EntryCreate",
          component: EntryCreate
        },
        {
          path: "entry/edit/:type/:parentId/:entryId",
          name: "EntryEdit",
          component: EntryEdit
        },
        {
          path: "admins",
          name: "AdminList",
          component: AdminList
        },
        {
          path: "users",
          name: "UserList",
          component: UserList
        },
        {
          path: "inquiries",
          name: "InquiryList",
          component: InquiryList
        },
        {
          path: "ebarimtsend",
          name: "EbarimtSend",
          component: SendEbarimt
        },
        {
          path: "admins/edit/:id",
          name: "AdminEdit",
          component: AdminEdit
        },
        {
          path: "admins/passwordchange/:id",
          name: "AdminPasswordChange",
          component: AdminPasswordChange
        },
        {
          path: "admins/register",
          name: "AdminRegister",
          component: AdminRegister
        },
        {
          path: "banner",
          name: "Banner",
          component: Banner
        },
        {
          path: "banner/create",
          name: "BannerCreate",
          component: BannerCreate
        },
        {
          path: "banner/edit/:id",
          name: "BannerEdit",
          component: BannerEdit
        },
        {
          path: "design",
          name: "Design",
          component: Design
        },
        {
          path: "stat/banner/:id",
          name: "BannerStatDetail",
          component: BannerStatisticDetail
        }
      ]
    },
    {
      path: "",
      component: Blank,
      children: [
        {
          path: "login",
          name: "Login",
          component: Login
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (localStorage.getItem("token") === null && to.fullPath !== "/login")
    next("/login");
  else next();
});

export default router;
